import { certificates } from '../certificate'
import { describeTable } from './describeTable'

describeTable(certificates, {
  description:
    'Master list of certificate types (kortit ja pätevyydet) that can be assigned to employees through employee_certificates. Maintained in the ERP configuration view; name is unique.',
})
